<div class="row">

    <input matInput placeholder="Enter web urls that you'd like to share" #linkInput [formControl]="linkCtrl"
        (keyup.enter)="enterLink($event)"><button mat-button color="primary" (click)="enterLink($event)">Add
        Link</button>
</div>
<div class="row">
    <mat-list role="list">
        <mat-list-item role="listitem" *ngFor="let link of links">{{link}} <i class="fas fa-trash-alt"
                (click)="removeLink(link)"></i>
        </mat-list-item>
    </mat-list>
</div>